import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch as useStoreDispatch } from "react-redux";
import auth from "./features/auth/authSlice";
import { userApiV1 } from "./features/user/userApiV1";
import { providerApiV1 } from "./features/provider/providerApiV1";
import { operatorApiV1 } from "./features/operator/operatorApiV1";
import { messageApiV1 } from "./features/message/messageApiV1";
import { verificationMessageApiV1 } from "@/features/verificationmessage/verificationMessageApiV1";
import { notificationApiV1 } from "@/features/message/notificationApiV1";

export const reducer = combineReducers({
  auth,
  [userApiV1.reducerPath]: userApiV1.reducer,
  [providerApiV1.reducerPath]: providerApiV1.reducer,
  [operatorApiV1.reducerPath]: operatorApiV1.reducer,
  [messageApiV1.reducerPath]: messageApiV1.reducer,
  [verificationMessageApiV1.reducerPath]: verificationMessageApiV1.reducer,
  [notificationApiV1.reducerPath]: notificationApiV1.reducer
});

export type StoreState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;

export const useDispatch = () => useStoreDispatch<AppDispatch>();

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ immutableCheck: false })
      .concat(userApiV1.middleware)
      .concat(providerApiV1.middleware)
      .concat(operatorApiV1.middleware)
      .concat(messageApiV1.middleware)
      .concat(verificationMessageApiV1.middleware)
      .concat(notificationApiV1.middleware),
});
